import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "toggle"];

  connect() {
    this.updateVisibility();
  }

  toggle() {
    this.updateVisibility();
  }

  updateVisibility() {
    const checked = this.inputTarget.checked;

    if (checked) {
      this.toggleTarget.classList.remove("hidden");
    } else {
      this.toggleTarget.classList.add("hidden");
    }
  }
}
